import { VE_DJANGO_CMS } from '@constants/common';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const tagTypes = ['Videos'];

// Apparently it's not needed but just in case, we include credentials for acceptance and internal environments
const needsCredentials = VE_DJANGO_CMS.includes('acceptance') || VE_DJANGO_CMS.includes('internal');

const headers = needsCredentials ? { Authorization: 'Basic ' + btoa('victron:victron') } : undefined;

const baseQuery = fetchBaseQuery({
    baseUrl: `${VE_DJANGO_CMS}/`,
    headers,
});

export const djangoCmsApi = createApi({
    baseQuery,
    tagTypes,
    endpoints: () => ({}),
    reducerPath: 'django_cms_api',
});
